<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" color="#fff" size="large" type="ball-atom" [fullScreen]="true"></ngx-spinner>
